import { useTranslation } from 'react-i18next'

interface CookieConsentBannerProps {
  open: boolean
  onAccept: () => void
  onDecline: () => void
}

/** Fixed bottom bar, shown until the visitor makes a choice (or reopened later via
 *  "Cookie-Einstellungen", see LegalLinks.tsx). Kept as a plain banner rather than a blocking
 *  modal - Google Analytics is optional, not required to use the platform, so nothing needs to be
 *  blocked while the visitor decides. */
export function CookieConsentBanner({ open, onAccept, onDecline }: CookieConsentBannerProps) {
  const { t } = useTranslation()

  if (!open) return null

  return (
    <div className="cookie-consent-banner" role="region" aria-label={t('cookieConsent.ariaLabel')}>
      <p>
        {t('cookieConsent.text')}{' '}
        <a href="/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">
          {t('cookieConsent.privacyLink')}
        </a>
      </p>
      <div className="cookie-consent-actions">
        <button type="button" className="btn-secondary" onClick={onDecline}>
          {t('cookieConsent.decline')}
        </button>
        <button type="button" className="btn-primary" onClick={onAccept}>
          {t('cookieConsent.accept')}
        </button>
      </div>
    </div>
  )
}
